import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
{
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/login/callback',
    name: 'KeycloakCallback',
    component: () => import('../views/KeycloakCallback.vue')
  },
  {
    path: '/cabinet',
    component: () => import('../layouts/CabinetLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('../views/cabinet/Dashboard.vue')
      },
      {
        path: 'drawings',
        name: 'Drawings',
        component: () => import('../views/cabinet/Drawings.vue')
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/cabinet/Profile.vue')
      },
      {
        path: 'support',
        name: 'Support',
        component: () => import('../views/cabinet/Support.vue')
      },
      {
        path: 'admin/users',
        name: 'AdminUsers',
        component: () => import('../views/admin/Users.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'admin/reports',
        name: 'AdminReports',
        component: () => import('../views/admin/Reports.vue'),
        meta: { requiresAdmin: true }
      },
      {
        path: 'admin/settings',
        name: 'AdminSettings',
        component: () => import('../views/admin/Settings.vue'),
        meta: { requiresAdmin: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.auth.isAuthenticated
  const isAdmin = store.state.auth.user?.is_admin

  // Уже авторизован — форма входа не нужна
  if (to.name === 'Login' && isAuthenticated) {
    next('/cabinet')
  } else if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresAdmin && !isAdmin) {
    next('/cabinet')
  } else {
    next()
  }
})

export default router

